import React, { ReactElement, useRef, useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { urgeInstallOrder,urgeAfterSalesOrder } from '../../../../api/filling-pile';
import { getLoginInfoPromise, getPlatform} from '../../../../utils/common';
import Toast from '../../../../components/toast';
import './index.less';

interface List {
  reason: number;
  content: string;
}
const installItem = [
  { text: '无人联系', value: 1 },
  { text: '未确定上门时间', value: 5 },
  { text: '提前上门时间', value: 7 },
  { text: '超过约定时间未上门', value: 9 },
  { text: '未及时提供资质协议等资料', value: 13 },
  { text: '未有效指导电力报装', value: 12  },
  { text: '未及时提供施工方案和报价', value: 11 },
  { text: '安装师傅态度差', value: 8 },
  { text: '不按收费标准收费', value: 10 },
  { text: '其他', value: 99 }
];

const afteSalesItem = [
  { text: '无人联系', value: 1 },
  { text: '未确定上门时间', value: 2 },
  { text: '提前上门时间', value: 3 },
  { text: '超过约定时间未上门', value: 4 },
  { text: '上门后未一次解决问题', value: 5 },
  { text: '维修师傅不专业要求更换人员', value: 6  },
  { text: '维修师傅态度差', value: 7 },
  { text: '其他', value: 99 }
];
export default function Urging(): ReactElement {
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);

  const router = useHistory();
  const [orderNo, setOrderNo] = useState('');
  const [flag, setFlag] = useState(true);
  const label = useRef<any>(null);
  const [reasonList, setReason] = useState<List>({
    reason: 1,
    content: ''
  });
  const setTitle = () => {
    document.title = '进度催办'
  }
  //选择催办原因
  const selectReason = (e, item) => {
    Array.from(label.current.children).forEach((item: any) => {
      item.classList.remove('label-active');
    });
    e.target.classList.add('label-active');
    const res: any = document.querySelector('.btn>button');
    setFlag(false);
    res.classList.add('disActive');
    const object = {
      reason: item.value,
      content: reasonList.content || ''
    };
    setReason(object);
  };

  //获取催办内容
  const urgContent = e => {
    const object = {
      reason: reasonList.reason,
      content: e.target.value
    };
    setReason(object);
  };
  //提交催办

  const submitUrg = async () => {
    const res = await getLoginInfoPromise();
    const phoneModel = getPlatform();
    let name: string = res.username;
    if (phoneModel === 'android') {
      name = res.nickname;
    }
    switch (loc.orderType) {
      case 'install':
        urgeInstallOrder({
          uid: res.uid,
          name: name,
          orderNo: orderNo,
          feedbackType: reasonList.reason,
          content: reasonList.content
        })
          .then(res => {
            console.log('install-res',res);
            if (res.data.code === 200) {
              Toast.show({
                text: '已催办，正在通知家充管家跟进',
                duration: 2000
              });
             router.goBack();
            }
          })
          .catch(() => {
            Toast.show({
              text: '网络开小差，请重试',
              duration: 2000
            });
          });
        
        break;
      case 'afterSales':
        urgeAfterSalesOrder({
          uid: res.uid,
          name: name,
          orderNo: orderNo,
          feedbackType: reasonList.reason,
          content: reasonList.content
        })
          .then(res => {
            console.log('afterSales-res',res);
            
            if (res.code === 0 && res.data) {
              Toast.show({
                text: '已催办，正在通知家充管家跟进',
                duration: 2000
              });
             router.goBack();
            }
          })
          .catch(() => {
            Toast.show({
              text: '网络开小差，请重试',
              duration: 2000
            });
          });
        
        break;
    
      default:
        break;
    }
  };
  
  const [formItem, setFormItem] = useState<any>(installItem)
  useEffect(() => {
    setTitle();
    const orderNo: any = params.get('orderNo');
    setOrderNo(orderNo);
    switch (loc.orderType) {
      case 'install':
        setFormItem(installItem)
        break;
      case 'afterSales':
        setFormItem(afteSalesItem)
        break;
    
      default:
        break;
    }
  }, []);
  return (
    <div className="urging">
      <div className="content">
        <div className="urg-reason">
          <div className="title">催办原因</div>
          <div className="label-content" ref={label}>
            {formItem.map((item, inx) => (
              <button
                className="label-item"
                key={inx}
                onClick={e => selectReason(e, item)}
              >
                {item.text}
              </button>
            ))}
          </div>
        </div>
        <div className="urg-content">
          <div className="title">催办内容</div>
          <div className="content-box">
            <textarea
              placeholder="请描述你遇到的问题"
              onChange={urgContent}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="btn">
        <button onClick={submitUrg} disabled={flag}>
          提交催办
        </button>
      </div>
    </div>
  );
}
